import { render, staticRenderFns } from "./wangEditReadOnly.vue?vue&type=template&id=664f1d12&scoped=true"
import script from "./wangEditReadOnly.vue?vue&type=script&lang=js"
export * from "./wangEditReadOnly.vue?vue&type=script&lang=js"
import style0 from "./wangEditReadOnly.vue?vue&type=style&index=0&id=664f1d12&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f1d12",
  null
  
)

export default component.exports